module.exports = __webpack_public_path__ + "static/media/file-alt.ce7a496c.svg";